/**
 * Local Language Item Component
 * Displays individual local language with name and description
 * Follows Single Responsibility Principle - only responsible for rendering a single language item
 * Uses shared BulletListItem component
 */

import React from 'react';
import { BulletListItem } from '../shared/BulletListItem';
import { LocalLanguageItemProps } from './types';

/**
 * Local Language Item Component
 * Renders a single local language item using the shared bullet list item component
 * Matches Figma design: bullet point with bold language name (heading) followed by colon and description
 * No individual borders - items are inside a bordered container
 */
export const LocalLanguageItem: React.FC<LocalLanguageItemProps> = ({
  language,
}) => {
  return (
    <BulletListItem
      item={{
        id: language.id,
        heading: language.name,
        description: language.description,
      }}
    />
  );
};
